/* @ngInject */
function FloatingBarDeleteController ($rootScope, $state, $scope, $timeout, $q, $translate, ModalService) {
  $scope.flags = {
    isSelectAll: false
  }

  const api = {}
  this.getApi = () => api

  activate()

  function activate () {}

  $scope.$watchCollection('selectedItems', () => {
    if ($scope.selectedItems.length === $scope.totalLength) {
      $scope.flags.isSelectAll = false
    }
  })

  $scope.handleSelectAll = () => {
    if ($scope.selectedItems.length === $scope.totalLength) {
      return $scope.handleUnSelectAll()
    }

    $scope.flags.isSelectAll = !$scope.flags.isSelectAll

    if ($scope.flags.isSelectAll) {
      return $scope.onSelectAll($scope.flags.isSelectAll)
    }

    $scope.handleUnSelectAll()
  }

  $scope.handleUnSelectAll = () => {
    $scope.onUnSelectAll()
  }

  $scope.handleDelete = () => {
    $scope.onDelete()
  }

  $scope.getFloatingBarTitle = () => {
    const itemsCount = $scope.selectedItems?.length || 0
    const textNeedsPlural = itemsCount > 1

    if (textNeedsPlural) {
      return `${itemsCount} ${$translate.instant('selectedsLowerCase')}`
    }

    return `${itemsCount} ${$translate.instant('selectedLowerCase')}`
  }

  $scope.getTooltipContentSelectAll = () => {
    const isTotalLength = $scope.selectedItems.length === $scope.totalLength

    if ($scope.flags.isSelectAll || isTotalLength) {
      return $translate.instant('deselectAll')
    }

    return $translate.instant('selectAll')
  }

  $scope.getTooltipContentDelete = () => {
    return $translate.instant('delete')
  }
}

export { FloatingBarDeleteController }
